<template>
    <b-modal 
        id="status-envio-mds-modal" 
        size="lg" 
        centered
        title="Registrar status de envio ao Portal MDS" 
        hide-footer
    >
        <form @submit.prevent="salvarStatus">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="status_envio" class="font-weight-bold">Status do Envio *</label>
                        <select
                            id="status_envio"
                            v-model="form.status_envio"
                            class="form-control"
                            required
                        >
                            <option value="">Selecione o status</option>
                            <option value="pendente">Pendente</option>
                            <option value="enviado_sucesso">Enviado com Sucesso</option>
                            <option value="falha_envio">Falha no Envio</option>
                        </select>
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group">
                        <label for="data_envio" class="font-weight-bold">Data de Envio *</label>
                        <input
                            id="data_envio"
                            v-model="form.data_envio"
                            type="datetime-local"
                            class="form-control"
                            required
                        />
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group">
                        <label for="observacoes" class="font-weight-bold">Observações</label>
                        <textarea
                            id="observacoes"
                            v-model="form.observacoes"
                            class="form-control"
                            rows="4"
                            placeholder="Ex: Arquivo rejeitado, erro de validação no Portal MDS."
                        ></textarea>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-12 text-right">
                    <button
                        type="button"
                        class="btn btn-secondary mr-2"
                        @click="cancelar"
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        class="btn btn-success"
                        :disabled="loading"
                    >
                        <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        Salvar Status
                    </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
export default {
    props: {
        rmaId: {
            type: Number,
            required: true
        }
    },
    name: "StatusEnvioMds",
    data() {
        return {
            loading: false,
            form: {
                status_envio: '',
                data_envio: this.getDefaultDateTime(),
                observacoes: ''
            }
        };
    },
    methods: {
        getDefaultDateTime() {
            const now = new Date();
            // Formatar para datetime-local (YYYY-MM-DDTHH:mm)
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        },
        salvarStatus() {
            if (!this.form.status_envio || !this.form.data_envio) {
                this.$snack.error({
                    text: 'Por favor, preencha todos os campos obrigatórios.',
                    button: false
                });
                return;
            }

            this.loading = true;
            
            axios.post(`api/dashboard/relatorio/rma-xml/${this.rmaId}/status/mds`, this.form)
                .then(response => {
                    this.$snack.success({
                        text: 'Status registrado com sucesso!',
                        button: false
                    });
                    this.fecharModal();
                    this.$emit('status-atualizado', response.data);
                })
                .catch(error => {
                    this.$snack.error({
                        text: 'Erro ao registrar status. Tente novamente.',
                        button: false
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        cancelar() {
            this.fecharModal();
        },
        fecharModal() {
            this.$bvModal.hide('status-envio-mds-modal');
            this.resetForm();
        },
        resetForm() {
            this.form = {
                status_envio: '',
                data_envio: this.getDefaultDateTime(),
                observacoes: ''
            };
        }
    },
};
</script>